/**
 * Links to the original source of everything IqraPath quotes (owner rule 2026-10-22: always link the source). Built from
 * references only, never typed by a person or an AI. Patterns verified in a browser on 2026-10-22.
 */

export const SOURCE_HOMES = {
  kemenag: 'https://quran.kemenag.go.id/',
  qurancom: 'https://quran.com/id',
  hadeethenc: 'https://hadeethenc.com/id/home',
} as const

/** Qur'an Kemenag (text, translation, Latin, tafsir): the verse range on quran.kemenag.go.id. */
export const kemenagUrl = (surah: number, from: number, to: number = from) =>
  `https://quran.kemenag.go.id/quran/per-ayat/surah/${surah}?from=${from}&to=${to}`

/** Quran.com (word-by-word meanings and word audio), Indonesian interface. */
export const qurancomUrl = (surah: number, from: number, to: number = from) =>
  `https://quran.com/id/${surah}/${from}${to > from ? `-${to}` : ''}`

/** HadeethEnc (hadith text, grade, syarah), Indonesian edition. */
export const hadeethencUrl = (id: string) => `https://hadeethenc.com/id/browse/hadith/${id}`
